import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { FeatureMapUserAccount } from '../admin/interfaces/user-accout.interface';
import { Searchable } from '../models/searchable.model';
import { VisibleFeature } from '../admin/interfaces/visible-feature.interface';

export type DefaultPermissionsPatch = Partial<Record<string, boolean>>;

@Injectable({
    providedIn: 'root'
})
export class UserAccountService {
    private readonly consumerPortalApi = inject(ConsumerPortalApiService);

    getUserAssignFeatures(customerId: string): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApi.get<Searchable & FeatureMapUserAccount>(`user-accounts/permissions/${customerId}`).pipe(
            map(data => {
                const response = data as unknown as FeatureMapUserAccount;
                return response;
            })
        );
    }

    getDefaultPermissions(customerId: string): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApi.get<Searchable & FeatureMapUserAccount>(`user-accounts/${customerId}/default-permissions`).pipe(map(data => data as unknown as FeatureMapUserAccount));
    }

    setDefaultPermissions(customerId: string, patch: DefaultPermissionsPatch): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApi
            .patch<Searchable & FeatureMapUserAccount>(`user-accounts/${customerId}/default-permissions`, {}, patch as unknown as Searchable & FeatureMapUserAccount)
            .pipe(map(data => data as unknown as FeatureMapUserAccount));
    }

    getVisibleFeatures(): Observable<VisibleFeature[]> {
        return this.consumerPortalApi.get<VisibleFeature>('organization-config/features/visible');
    }
}
